import React, { useContext, useEffect } from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import { EasybakeContext } from '../EasybakeProvider'
import Heading from '@react/react-spectrum/Heading'
import BookMeetingButton from './BookMeetingButton'
import { setBodyHeight } from '../../lib/easybake'

export default function EnterpriseSetupMeeting () {

    useEffect(() => {
        window.scrollTo(0, 0);
        if (window.easybake) {
            window.easybake.parent.getURL().then((data) => {
                setBodyHeight('adobe-easybake-main-sub-pane')
            })
        }
    }, [window.easybake])

    return <div className="adobe-easybake-main-pane-full">
        <div className="adobe-easybake-main adobe-easybake-home">
            <div className="adobe-easybake-home-content">
                <div className="adobe-easybake-main-sub-pane-contents-signup">
                    <div className="adobe-easybake-main-sub-pane-header">
                        <Heading variant="pageTitle" className="adobe-easybake-console-title">{__('console_enterprise_setup_meeting_title')}</Heading>
                        <br />
                        <p>{__('console_enterprise_setup_meeting_desc')}</p>
                        <br />
                        <br />
                        <br />
                        <BookMeetingButton />
                        <br />
                    </div>
                </div>
            </div>
        </div>
    </div>
}
